import React, { useEffect, useState } from "react";

import { setZeroBalances } from "../services/settingsService";
import { useToast } from "../hooks/use-toast";
import { useAuth } from "../context/AuthContext";
import { Switch } from "./ui/switch";

const HideZeroBalancesRow = () => {
  const { toast } = useToast();
  const { userProfile, settings, updateSettings } = useAuth();
  const [isChecked, setIsChecked] = useState(
    settings?.digitalWallet?.hideZeroBalances
  );

  async function updateHideAllBals(data) {
    const userId = userProfile._id;
    var old_state = false;

    if (data === true) {
      old_state = false;
    } else {
      old_state = true;
    }
    setIsChecked(data);
    try {
      const apiCall = await setZeroBalances(userId);

      if (apiCall.status === 200 && apiCall.data.status === true) {
        const newSettings = apiCall.data.data;

        updateSettings(newSettings);
        toast({
          description: "Hide zero balances Updated Successfully",
          variant: "eighty",
        });
      } else {
        setIsChecked(old_state);
      }
    } catch (err) {
      setIsChecked(old_state);
      toast({
        description: "Error Updating Currency",
        variant: "eighty",
      });
    }
  }

  useEffect(() => {
    if (settings) setIsChecked(settings?.digitalWallet?.hideZeroBalances);
  }, [settings]);

  return (
    <>
      <div
        className="flex items-center justify-between px-4 py-6 bg-white border border-gray-200 rounded-md hover:bg-gray-50 cursor-pointer"
        onClick={() => {}}
      >
        <p className="text-sm font-semibold text-[16px] text-text-primary">
          Hide zero balances
        </p>
        <Switch
          className="bg-rose-100 data-[state=checked]:bg-rose-500"
          checked={isChecked}
          onCheckedChange={(e) => {
            updateHideAllBals(e);
          }}
        />
      </div>
    </>
  );
};

export default HideZeroBalancesRow;
